module.exports = __webpack_public_path__ + "static/media/landings4.a8cab692.webp";